var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "add-task-wrapper" },
    [
      _vm._t(
        "default",
        function () {
          return [
            _c(
              "button",
              {
                on: {
                  click: _vm.showModal,
                  mouseover: function ($event) {
                    _vm.isHovered = true
                  },
                  mouseout: function ($event) {
                    _vm.isHovered = false
                  },
                },
              },
              [
                !_vm.isHovered
                  ? _c("AddIcon", { staticClass: "w-4 h-4" })
                  : _vm._e(),
                _vm.isHovered
                  ? _c("AddIconHover", { staticClass: "w-4 h-4" })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        { showModal: _vm.showModal }
      ),
      _vm.modalShown
        ? _c("ActivityFormModal", {
            attrs: {
              project: _vm.project,
              projectId: _vm.projectId,
              projectActivity: _vm.projectActivity,
              currentUserRole: _vm.currentUserRole,
              companyId: _vm.companyId,
              currentUserId: _vm.currentUser.id,
            },
            on: {
              activityAdded: _vm.onActivityAdded,
              activityUpdated: _vm.hideModal,
              close: _vm.hideModal,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }